const cookie = {
  get(name) {
    let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    let arr = document.cookie.match(reg);
    if (document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  set(name, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      name +
      "=" +
      escape(value) +
      (expiredays === null ? "" : ";expires=" + exdate.toGMTString());
  },
};

export default cookie;
